export default "__VITE_ASSET__DHVpv4GI__"